// extracted by mini-css-extract-plugin
export default {"page":"FBe8Hn62WNzvShuD8AFDjQ==","main":"yWsjHGvmLXwK+XpATZoRow=="};